import { render, staticRenderFns } from "./PageStart.vue?vue&type=template&id=d979dbdc"
import script from "./PageStart.vue?vue&type=script&lang=js"
export * from "./PageStart.vue?vue&type=script&lang=js"
import style0 from "./PageStart.vue?vue&type=style&index=0&id=d979dbdc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports